<template>
  <a class="hl-button" :href="url" :class="{ 'hl-button--white': isWhite }">
	<slot></slot>   	
    
  </a>
</template>

<script>
export default {
	props: {
		url: {
			type: String,
			default: "#"
		},
		isWhite: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
	.hl-button,
	input[type=submit] {
		padding: 0.5rem 1.5rem;
		border: none;
		background-color: $midnight;
		color: $white;

		&:hover {
			text-decoration: none;
			background-color: $midnightHover;
			color: $white;
		}

		&.hl-button--white {
			background-color: $coolWhite;
			color: $midnight;

			&:hover {
				background-color: $cloud;
				color: $navyBlue !important;
			}

		}

		transition: all 0.25s;
		display: inline-block;
		text-align: center;
		&.hl-button--is-wide {
			width: 195px;
		}

	}

	.video-play-icon {
		@include bgicon();
		background-image: get-icon( 'video-play-icon', $white );
	}

	.arrow-back-icon {
		@include bgicon();
		background-image: get-icon( 'arrow-back', $white );
	}

	.hl-button {
		.video-play-icon {
			width: 19px;
			height: 19px;
			margin-right: 0.5em;
		}

		&:hover .video-play-icon {
			background-image: get-icon( 'video-play-icon', $navyBlue );
		}

		.arrow-back-icon {
			width: 26px;
			height: 16px;
		}

		&:hover .arrow-back-icon {
			background-image: get-icon( 'arrow-back', $navyBlue );
		}

	}

	.background-is-dark {
		.hl-button {
		}
	}

</style>
